import FireBaseTools from '../utils/firebase';

// / FIREBASE AUTH ACTIONS
// export const LOGIN_WITH_PROVIDER_FIREBASE = 'LOGIN_WITH_PROVIDER_FIREBASE';

export const REGISTER_FIREBASE_USER = 'REGISTER_FIREBASE_USER';
export const REGISTER_FIREBASE_USER_SUCCESS = 'REGISTER_FIREBASE_USER_SUCCESS';
export const REGISTER_FIREBASE_USER_FAILURE = 'REGISTER_FIREBASE_USER_FAILURE';
export const SEND_EMAIL_VERIFICATION = 'SEND_EMAIL_VERIFICATION';
export const EMAIL_VERIFICATION_SENT = 'EMAIL_VERIFICATION_SENT';
export const EMAIL_VERIFICATION_ERROR = 'EMAIL_VERIFICATION_ERROR';

export const CONFIRM_PASSWORD_RESET_LINK = 'CONFIRM_PASSWORD_RESET_LINK';
export const VALID_RESET_PASSWORD_LINK = 'VALID_RESET_PASSWORD_LINK';
export const INVALID_RESET_PASSWORD_LINK = 'INVALID_RESET_PASSWORD_LINK';
export const CONFIRM_PASSWORD_RESET = 'CONFIRM_PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESSFUL = 'PASSWORD_RESET_SUCCESSFUL';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';

export const CONFIRM_EMAIL_VERIFICATION_LINK = 'CONFIRM_EMAIL_VERIFICATION_LINK';
export const EMAIL_VERIFICATION_SUCCESSFUL = 'EMAIL_VERIFICATION_SUCCESSFUL';
export const EMAIL_VERIFICATION_FAILED = 'EMAIL_VERIFICATION_FAILED';

export const LOGIN_FIREBASE_USER = 'LOGIN_FIREBASE_USER';
export const LOGIN_FIREBASE_USER_SUCCESS = 'LOGIN_FIREBASE_USER_SUCCESS';
export const LOGIN_FIREBASE_USER_FAILED = 'LOGIN_FIREBASE_USER_FAILED';

// export const FETCH_FIREBASE_USER = 'FETCH_FIREBASE_USER';
// export const FETCH_FIREBASE_USER_SUCCESS = 'FETCH_FIREBASE_USER_SUCCESS';
// export const FETCH_FIREBASE_USER_FAILED = 'FETCH_FIREBASE_USER_FAILED';

export const UPDATE_FIREBASE_USER = 'UPDATE_FIREBASE_USER';
export const UPDATE_FIREBASE_USER_FAILED = 'UPDATE_FIREBASE_USER_FAILED';
export const CHANGE_FIREBASE_USER_PASSWORD = 'CHANGE_FIREBASE_USER_PASSWORD';
export const FIREBASE_PASSWORD_RESET_EMAIL = 'FIREBASE_PASSWORD_RESET_EMAIL';
export const LOGOUT_FIREBASE_USER = 'LOGOUT_FIREBASE_USER';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_FAILED = 'CHANGE_USER_PASSWORD_FAILED';
export const FIREBASE_PASSWORD_RESET_EMAIL_SUCCESS = 'FIREBASE_PASSWORD_RESET_EMAIL_SUCCESS';
export const FIREBASE_PASSWORD_RESET_EMAIL_FAILED = 'FIREBASE_PASSWORD_RESET_EMAIL_FAILED';


// export function loginWithProvider(provider) {
//   const request = FireBaseTools.loginWithProvider(provider);
//   return {
//     type: LOGIN_WITH_PROVIDER_FIREBASE,
//     payload: request,
//   };
// }

// export function loginUser(user) {
//   console.log('loginUser', user);
//   return {
//     type: LOGIN_FIREBASE_USER,
//     user,
//   };
// }
//
// export function loginUserSuccess(user) {
//   console.log('loginUserSuccess', user);
//   return {
//     type: LOGIN_FIREBASE_USER_SUCCESS,
//     user,
//   };
// }
//
// export function loginUserFailed(error) {
//   console.log('loginUserFailed', error);
//   return {
//     type: LOGIN_FIREBASE_USER_FAILED,
//     error,
//   };
// }

export function updateUser(user) {
  const request = FireBaseTools.updateUserProfile(user);
  const userData = {
    email: request.email,
    displayName: request.displayName,
    photoURL: request.photoURL,
  };
  return {
    type: UPDATE_FIREBASE_USER,
    payload: userData,
  };
}

export function updateUserEmail(email) {
  const request = FireBaseTools.updateUserEmail(email);
  const userData = {
    email: request.email,
    displayName: request.displayName,
    photoURL: request.photoURL,
  };
  return {
    type: UPDATE_FIREBASE_USER,
    payload: userData,
  };
}

export function updateUserFail(message) {
  return {
    type: UPDATE_FIREBASE_USER_FAILED,
    message,
  };
}

export function changePassword(newPassword) {
  return {
    type: CHANGE_FIREBASE_USER_PASSWORD,
    newPassword,
  };
}

export function changeUserPasswordSuccess() {
  return {
    type: CHANGE_USER_PASSWORD_SUCCESS,
    message: 'Password has been successfully updated',
  };
}
export function changeUserPasswordFailed(error) {
  return {
    type: CHANGE_USER_PASSWORD_FAILED,
    message: error.message,
  };
}

// export function resetPasswordEmail(email) {
//   return {
//     type: FIREBASE_PASSWORD_RESET_EMAIL,
//     email,
//   };
// }
//
// export function resetPasswordEmailSuccess() {
//   return {
//     type: FIREBASE_PASSWORD_RESET_EMAIL_SUCCESS,
//     message: 'Please see your email!',
//   };
// }
//
// export function resetPasswordEmailFailed(error) {
//   return {
//     type: FIREBASE_PASSWORD_RESET_EMAIL_FAILED,
//     message: error.message,
//   };
// }

// export function logoutUser(user) {
//   const request = FireBaseTools.logoutUser(user);
//   return {
//     type: LOGOUT_FIREBASE_USER,
//     payload: request,
//   };
// }

export function confirmPasswordResetLink(oobCode) {
  return {
    type: CONFIRM_PASSWORD_RESET_LINK,
    oobCode,
  };
}

export function validResetPasswordLink() {
  return {
    type: VALID_RESET_PASSWORD_LINK,
    message: 'valid',
  };
}

export function inValidResetPasswordLink() {
  return {
    type: INVALID_RESET_PASSWORD_LINK,
    message: 'inValid',
  };
}

export function confirmPasswordReset(code, newPassword) {
  return {
    type: CONFIRM_PASSWORD_RESET,
    code,
    newPassword,
  };
}

export function passwordResetSuccessful(success) {
  return {
    type: PASSWORD_RESET_SUCCESSFUL,
    success,
  };
}

export function passwordResetFailure(error) {
  console.log('passwordResetFailure', error);
  return {
    type: PASSWORD_RESET_FAILURE,
    error,
  };
}

export function confirmEmailVerificationLink(code) {
  return {
    type: CONFIRM_EMAIL_VERIFICATION_LINK,
    code,
  };
}

export function emailVerificationSuccess(success) {
  return {
    type: EMAIL_VERIFICATION_SUCCESSFUL,
    success,
  };
}

export function emailVerificationFailed() {
  return {
    type: EMAIL_VERIFICATION_FAILED,
    message: 'inValid',
  };
}



// WEBPACK FOOTER //
// ./src/actions/firebase.js